// original with user login or signup 


import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import AdminLayout from './admin/AdminLayout';
import Login from './admin/Login/Login';
import Dashboard from './admin/Dashboard/Dashboard';
import Home from './admin/Home/Home';
import PropertyList from './admin/PropertyList/PropertyList';
import AddNewProperty from './admin/AddProperty/AddNewProperty';
import TypeList from './admin/TypeList/TypeList';
import AddType from './admin/AddType/AddType';
import CommentList from './admin/CommentList/CommentList';
import { isLogin } from './utils/checkAuth';
import UserLayout from './user/UserLayout';
import UserHome from './user/UserHome/UserHome';
import About from './user/AboutUs/About';
import Contact from './user/Contact/Contact';
import Property from './user/Property/Property';
import Signup from './user/Signup';
import UserLogin from './user/UserLogin';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/uhome" replace />
  },
  { 
    path: 'login', 
    element: <UserLogin />
  },
  { 
    path: 'signup', 
    element: <Signup />
  },
  {
    path: 'uhome',
    element: <UserLayout />,
    children: [
      { path: '', element: <UserHome /> },
      { path: 'home', element: <UserHome /> },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <Contact /> },
      { path: 'property', element: <Property /> },
      { path: 'property/:id', element: <Property /> }
    ]
  },
  {
    path: 'admin',
    element: <AdminLayout />,
    children: [
      { 
        path: 'login', 
        element: <Login />,
        loader: () => {
          const token = localStorage.getItem('token');
          const userType = localStorage.getItem('userType');
          if (token && userType === 'admin') {
            throw new Navigate({ to: '/admin/dashboard' });
          }
          return null;
        }
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
        errorElement: <Navigate to="/admin/login" />,
        loader: async () => {
          try {
            const auth = await isLogin();
            if (auth.userType !== 'admin') {
              throw new Error('unauthorized');
            }
            return auth;
          } catch (error) {
            throw new Navigate({ to: '/admin/login' });
          }
        },
        children: [
          { path: '', element: <Home /> },
          { path: 'property', element: <PropertyList /> },
          { path: 'add-property', element: <AddNewProperty key="add-property" mode="add-property" /> },
          { path: 'type', element: <TypeList /> },
          { path: 'add-type', element: <AddType key="add" mode="add" /> },
          { path: 'comment', element: <CommentList /> },
          { path: 'edit-type', element: <AddType key="edit" mode="edit" /> },
          { path: 'edit-property', element: <AddNewProperty key="edit-property" mode="edit-property" /> }
        ]
      }
    ]
  }
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Analytics />
    </>
  );
}

export default App;
